import { render, staticRenderFns } from "./IVCCarousel.vue?vue&type=template&id=a08acd98&scoped=true&"
import script from "./IVCCarousel.vue?vue&type=script&lang=js&"
export * from "./IVCCarousel.vue?vue&type=script&lang=js&"
import style0 from "./IVCCarousel.vue?vue&type=style&index=0&id=a08acd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08acd98",
  null
  
)

export default component.exports